import type GetPlaidDesktopMessage from './types';

const getPlaidDesktopMessage: GetPlaidDesktopMessage = () => undefined;

export default getPlaidDesktopMessage;
